import { CarDetailsType, CarFeatureInterface, Feature_SKELETON } from '@/types';
import ModalInfo, {
    IModalData,
} from '../CarProfileNew/InfoModal/modal-info.component';
import { useEffect, useState } from 'react';
import SwipeableDrawer from '@/components/shared/bottom-sheet/bottom-sheet.component';
import Modal from '@/components/shared/modal.component';
import { TFunction } from 'i18next';
import Image from 'next/image';
import {
    ComfortConvenienceIconImg,
    DimensionsCapacityIconImg,
    EntertainmentCommunicationIconImg,
    ExteriorIconImg,
    InteriorIconImg,
    PerformanceFeatureIconImg,
    SafetyIconImg,
    SylndrCertified,
} from '../../../../public/Images';

const CarFeaturesSection = ({
    carDetails,
    IS_DESKTOP,
    openFeatureContainer,
    carDetailsState,
    setOpenFeatureContainer,
    t,
    featureValue,
}: {
    carDetails: CarDetailsType;
    IS_DESKTOP: boolean;
    openFeatureContainer: boolean;
    carDetailsState: any;
    setOpenFeatureContainer: React.Dispatch<React.SetStateAction<boolean>>;
    t: TFunction<'translation', undefined>;
    featureValue: number;
}) => {
    const [carFeaturesNew, setCarFeaturesNew] = useState<IModalData[]>();

    useEffect(() => {
        intiatCarFeatures(carDetails);
    }, [carDetails]);
    const featuresLabelsAndImages = {
        PerformanceFeatures: {
            name: t('Performance Features'),
            element: (
                <Image
                    src={PerformanceFeatureIconImg}
                    alt="PerformanceFeatureIconImg"
                    height={32}
                    width={32}
                />
            ),
            index: 0,
        },
        ComfortFeatures: {
            name: t('Comfort & Convenience'),
            element: (
                <Image
                    src={ComfortConvenienceIconImg}
                    alt="ComfortConvenienceIconImg"
                    height={32}
                    width={32}
                />
            ),
            index: 1,
        },
        EntertainmentFeatures: {
            name: t('Entertainment & Communication'),
            element: (
                <Image
                    src={EntertainmentCommunicationIconImg}
                    alt="EntertainmentCommunicationIconImg"
                    height={32}
                    width={32}
                />
            ),
            index: 2,
        },
        InteriorFeatures: {
            name: t('Interiors'),
            element: (
                <Image
                    src={InteriorIconImg}
                    alt="InteriorIconImg"
                    height={32}
                    width={32}
                />
            ),
            index: 3,
        },
        SafteyFeatures: {
            name: t('Safety'),
            element: (
                <Image
                    src={SafetyIconImg}
                    alt="SafetyIconImg"
                    height={32}
                    width={32}
                />
            ),
            index: 4,
        },

        ExteriorFeatures: {
            name: t('Exteriors'),
            element: (
                <Image
                    src={ExteriorIconImg}
                    alt="Exterior features icon"
                    height={32}
                    width={32}
                />
            ),
            index: 5,
        },
        DimensionFeatures: {
            name: t('Dimensions & Capacity'),
            element: (
                <Image
                    src={DimensionsCapacityIconImg}
                    alt="Dimensions and capacity icon"
                    height={32}
                    width={32}
                />
            ),
            index: 6,
        },
        SylndrAssured: {
            name: t('Sylndr certified'),
            element: (
                <Image
                    src={SylndrCertified}
                    alt="Sylndr certified icon"
                    height={32}
                    width={32}
                />
            ),
            index: 7,
        },
    };
    const intiatCarFeatures = (carDetails: any) => {
        const tempArr = Array(carDetails?.vehicleFeature.length);
        for (let j = 0; j < carDetails?.vehicleFeature.length; j += 1) {
            const properties = carDetails.vehicleFeature[j].featureProperties;
            const featureSection = carDetails.vehicleFeature[j]?.name;
            // eslint-disable-next-line @typescript-eslint/prefer-for-of
            for (let k = 0; k < properties.length; k += 1) {
                Feature_SKELETON[
                    featureSection as keyof typeof Feature_SKELETON
                ].set(properties[k]?.name, properties[k]);
            }
        }
        for (let i = 0; i < carDetails?.vehicleFeature.length; i += 1) {
            if (carDetails?.vehicleFeature[i]) {
                const featureSection = carDetails?.vehicleFeature[i].name;
                const name =
                    featuresLabelsAndImages[
                        featureSection as keyof typeof featuresLabelsAndImages
                    ].name;

                const properties: CarFeatureInterface[] = [];
                Feature_SKELETON[
                    featureSection as keyof typeof Feature_SKELETON
                ]?.forEach(item => {
                    if (item.value !== '') properties.push(item);
                });

                const featureObj: IModalData = {
                    icon: featuresLabelsAndImages[
                        featureSection as keyof typeof featuresLabelsAndImages
                    ].element,
                    name: name,
                    data: {
                        properties: [...properties],
                        title: name,
                    },
                    applyGallery: carDetails?.newGallery,
                };

                tempArr[
                    featuresLabelsAndImages[
                        carDetails?.vehicleFeature[i]
                            .name as keyof typeof featuresLabelsAndImages
                    ].index
                ] = featureObj;
            }
        }

        if (tempArr.length > 0) {
            setCarFeaturesNew(tempArr);
        }
    };

    return (
        <>
            {carFeaturesNew &&
                (!IS_DESKTOP ? (
                    <SwipeableDrawer
                        open={openFeatureContainer}
                        setOpen={setOpenFeatureContainer}
                    >
                        <ModalInfo
                            isSold={
                                carDetails?.isSold ||
                                carDetails?.isPurchaseInProgress
                            }
                            id={carDetailsState?.id}
                            isReserved={carDetailsState?.isReserved}
                            valueType="text"
                            data={carFeaturesNew}
                            title={t('Car Features')}
                            clickedItem={featureValue}
                            open={openFeatureContainer}
                            setOpen={setOpenFeatureContainer}
                            bookingType={carDetails?.bookingType}
                        />
                    </SwipeableDrawer>
                ) : (
                    <Modal
                        open={openFeatureContainer}
                        setOpen={setOpenFeatureContainer}
                    >
                        <div className="w-[646px] p-6">
                            <ModalInfo
                                isSold={
                                    carDetails?.isSold ||
                                    carDetails?.isPurchaseInProgress
                                }
                                id={carDetailsState?.id}
                                isReserved={carDetailsState?.isReserved}
                                valueType="text"
                                data={carFeaturesNew}
                                title={t('Car Features')}
                                clickedItem={featureValue}
                                open={openFeatureContainer}
                                setOpen={setOpenFeatureContainer}
                                bookingType={carDetails?.bookingType}
                            />
                        </div>
                    </Modal>
                ))}
        </>
    );
};
export default CarFeaturesSection;
